export enum IncentiveDictKey {
  SKU_NAME = 'SKU_NAME',
  STORE_NAME = 'STORE_NAME',
  CURRENT_SALES = 'CURRENT_SALES',
  UNIT_PRICE = 'UNIT_PRICE',
  PRODUCT_DETAIL = 'PRODUCT_DETAIL',
  URL = 'URL',
  BRAND_NAME = 'BRAND_NAME',
  SHARE_OF_LIVESTREAM_SKU = 'SHARE_OF_LIVESTREAM_SKU',
  SALES_OF_LIVESTREAM_SKU = 'SALES_OF_LIVESTREAM_SKU',
  SALES_AFTER_DISCOUNT = 'SALES_AFTER_DISCOUNT',
  DISCOUNT_RATE = 'DISCOUNT_RATE',
  UNIT_PRICE_BY_SEGMENT = 'UNIT_PRICE_BY_SEGMENT',
  SHARE_OF_CATEGORY_UNIT_PRICE = 'SHARE_OF_CATEGORY_UNIT_PRICE',
  TITLE = 'TITLE',
}
